/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_Step_4Inputs */

const da_forside_example_step_4 = /** @type {(inputs: Forside_Example_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload de tre besvarelser under Besvarelser, og dæk navnene.`)
};

/** @type {(inputs: Forside_Example_Step_4Inputs) => LocalizedString} */
const en_forside_example_step_4 = da_forside_example_step_4;

/**

* @param {Forside_Example_Step_4Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_step_4 = /** @type {((inputs?: Forside_Example_Step_4Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_Step_4Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_step_4(inputs)
	return /** @type {LocalizedString} */ ("Upload de tre besvarelser under Besvarelser, og dæk navnene.")
});